<template>
  <div class="bg-container page register-page">
    <div class="dong_box">
      <div class="dong_i"></div>
    </div>
    <div class="bg-wrapper">
      <div class="register">
        <van-nav-bar class="nav-bar">
          <template #left>
            <div class="nav-back" @click="back">
              <img src="/img/common/icon-back.png" alt="" />
              <span>{{ $t('注册.登录') }}</span>
            </div>
          </template>
        </van-nav-bar>
        <div class="wrapper">
          <div class="title">{{ $t('注册.注册') }}</div>
          <div class="loginForm">
            <van-field
              v-model="username"
              clearable
              input-align="center"
              class="input"
              :placeholder="$t('注册.请输入用户名')"
            />
            <div class="sm_tit">{{ $t('注册.用户名规则') }}</div>

            <van-field
              v-model="password"
              :type="passwordType"
              input-align="center"
              class="input"
              :placeholder="$t('注册.请输入密码')"
            >
              <template slot="right-icon">
                <van-icon
                  :name="passwordType === 'password' ? 'closed-eye' : 'eye-o'"
                  @click="switchPasswordType"
                />
              </template>
            </van-field>
            <div class="sm_tit">{{ $t('注册.密码规则') }}</div>

            <div class="captcha-row">
              <van-field
                v-model="captcha"
                input-align="center"
                class="input captcha-input"
                :placeholder="$t('注册.请输入验证码')"
              />
              <Captcha ref="Captcha" class="captcha-box" />
            </div>
            <div class="sm_tit">{{ $t('注册.验证码规则') }}</div>

            <van-field
              v-model="inviteCode"
              :clearable="!inviteLocked"
              :readonly="inviteLocked"
              input-align="center"
              class="input"
              :class="{ 'invite-locked': inviteLocked }"
              :placeholder="$t('注册.请输入邀请码')"
            />
            <div class="sm_tit">{{ $t('注册.邀请码规则') }}</div>

            <div class="agreement">
              <van-checkbox v-model="agreed" checked-color="#7e5678" />
              <span class="agreement-text">{{ $t('注册.同意协议') }}</span>
            </div>

            <van-button
              class="login-btn"
              type="primary"
              size="normal"
              :loading="registering"
              :disabled="registering"
              @click="doRegister"
            >
              {{ registering ? $t('注册.注册中') : $t('注册.注册') }}
            </van-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Captcha from './Captcha.vue'

export default {
  name: 'RegisterPage',
  components: { Captcha },
  data() {
    return {
      username: '',
      password: '',
      captcha: '',
      inviteCode: '',
      inviteLocked: false,
      agreed: false,
      passwordType: 'password',
      registering: false,
    }
  },
  created() {
    const code = this.$route.query.code
    if (code) {
      this.inviteCode = String(code).trim()
      this.inviteLocked = !!this.inviteCode
    }
    if (this.inviteLocked && localStorage.getItem('token')) {
      const lang = localStorage.getItem('language')
      localStorage.removeItem('token')
      if (lang) localStorage.setItem('language', lang)
    } else if (localStorage.getItem('token')) {
      this.$router.replace({ path: '/Home' })
    }
  },
  methods: {
    switchPasswordType() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
    },
    back() {
      if (window.history.length > 1) {
        this.$router.go(-1)
      } else {
        this.$router.replace({ path: '/Login' })
      }
    },
    validateForm() {
      const username = this.username.trim()
      const password = this.password.trim()
      const captcha = this.captcha.trim()
      const inviteCode = this.inviteCode.trim()

      if (!username) {
        this.$toast.fail(this.$t('注册.请输入用户名'))
        return false
      }
      if (username.length < 6 || username.length > 20) {
        this.$toast.fail(this.$t('注册.用户名规则'))
        return false
      }
      if (!password) {
        this.$toast.fail(this.$t('注册.请输入密码'))
        return false
      }
      if (password.length < 6 || password.length > 16) {
        this.$toast.fail(this.$t('注册.密码规则'))
        return false
      }
      if (!captcha) {
        this.$toast.fail(this.$t('注册.请输入验证码'))
        return false
      }
      if (!inviteCode) {
        this.$toast.fail(this.$t('注册.请输入邀请码'))
        return false
      }
      if (!this.agreed) {
        this.$toast.fail(this.$t('注册.请同意注册条款'))
        return false
      }
      return true
    },
    doRegister() {
      if (!this.validateForm()) return

      const captchaKey = this.$refs.Captcha ? this.$refs.Captcha.getKey() : ''
      if (!captchaKey) {
        this.$toast.fail(this.$t('注册.请输入验证码'))
        if (this.$refs.Captcha) this.$refs.Captcha.refreshCaptcha()
        return
      }

      this.registering = true
      this.$http({
        method: 'post',
        url: 'member_register',
        data: {
          username: this.username.trim(),
          password: this.password.trim(),
          code: this.inviteCode.trim(),
          captcha: this.captcha.trim(),
          captcha_key: captchaKey,
        },
      })
        .then((res) => {
          if (res.code === 200) {
            this.$toast.success(res.msg || this.$t('注册.注册成功'))
            if (res.data) localStorage.setItem('userId', res.data)
            setTimeout(() => {
              this.$router.push({ path: '/Login' })
            }, 1500)
            return
          }
          this.$toast.fail(res.msg || this.$t('注册.注册失败'))
          this.captcha = ''
          if (this.$refs.Captcha) this.$refs.Captcha.refreshCaptcha()
        })
        .catch(() => {
          this.$toast.fail(this.$t('注册.注册失败'))
          if (this.$refs.Captcha) this.$refs.Captcha.refreshCaptcha()
        })
        .finally(() => {
          this.registering = false
        })
    },
  },
}
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";

@keyframes login-bg-shift {
  0%, 100% { background-position-x: 0; }
  50% { background-position-x: 100%; }
}

.register-page {
  min-height: 100%;
  background: #1f1c1f;
}

.dong_box {
  position: absolute;
  inset: 0;
  z-index: 0;
  overflow: hidden;

  .dong_i {
    height: 100%;
    width: 100%;
    animation: login-bg-shift 20s linear infinite;
    background: url(/img/login/bg.jpg) no-repeat 0 0;
    background-size: auto 100%;
  }
}

.bg-container .bg-wrapper {
  z-index: 1;
  background: rgba(0, 0, 0, 0.55);
  background-size: 100% 100%;
}

.register {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.bg-container .bg-wrapper .register .nav-bar {
  background: transparent;
  border-bottom: none;
  flex-shrink: 0;
}

.nav-back {
  display: flex;
  align-items: center;

  img {
    width: 36px;
    height: 28px;
    object-fit: contain;
  }

  span {
    margin-left: 12px;
    font-size: 28px;
    color: #f3c7a2;
  }
}

.wrapper {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 40px;
  box-sizing: border-box;
}

.title {
  line-height: 1.2;
  padding: 10px 0 8px;
  text-align: center;
  font-size: 36px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 3px;
}

.loginForm {
  padding: 10px 40px 0;

  .input {
    position: relative;
    width: 100% !important;
    height: 88px;
    min-height: 88px;
    box-sizing: border-box;
    padding: 0 72px 0 28px !important;
    margin-top: 8px;
    border-radius: 12px;
    font-size: 28px;
    color: #e6b98a;
    background: linear-gradient(120deg, #212121, #313131);
    border: 2px solid #766350;
    overflow: hidden;

    &.invite-locked {
      opacity: 0.85;
    }
  }

  .captcha-row {
    display: flex;
    align-items: center;
    margin-top: 8px;
    gap: 16px;

    .captcha-input {
      flex: 1;
      margin-top: 0;
      padding-right: 28px !important;
    }

    .captcha-box {
      flex-shrink: 0;
    }
  }

  .login-btn {
    margin-top: 48px;
    width: 100%;
    height: 84px;
    border: none;
    border-radius: 50px;
    color: #68302c;
    background: linear-gradient(#fde3ca, #e7b486);
    font-size: 30px;
    font-weight: bolder;

    &:disabled {
      opacity: 0.6;
    }
  }
}

.sm_tit {
  font-size: 20px;
  color: rgba(255, 255, 255, 0.72);
  padding-left: 8px;
  margin: 8px 0 18px;
  line-height: 1.4;
  word-break: break-word;
}

.agreement {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;

  .agreement-text {
    margin-left: 12px;
    font-size: 24px;
    color: #fff;
    font-weight: 500;
    line-height: 1.4;
  }
}

::v-deep .loginForm .van-cell::after {
  display: none;
}

::v-deep .loginForm .van-field__value,
::v-deep .loginForm .van-field__body {
  height: 100%;
  width: 100%;
}

::v-deep .loginForm .van-field__body {
  display: flex;
  align-items: center;
}

::v-deep .loginForm .van-field__control {
  display: block;
  width: 100%;
  height: 88px;
  line-height: 88px;
  padding: 0;
  margin: 0;
  font-size: 28px;
  color: #e6b98a;
  text-align: center;
  caret-color: #e6b98a;
}

::v-deep .loginForm .van-field__right-icon,
::v-deep .loginForm .van-field__clear {
  position: absolute;
  top: 50%;
  right: 18px;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
  transform: translateY(-50%);
  line-height: 1;
  font-size: 36px;
  color: #e6b98a;
}

::v-deep .loginForm .van-field__right-icon .van-icon {
  font-size: 36px;
  color: #e6b98a;
  line-height: 1;
}

::v-deep .agreement .van-checkbox__icon {
  font-size: 36px;
}

::v-deep .agreement .van-checkbox__icon .van-icon {
  border-color: #766350;
}
</style>